import { memo } from 'react';

import { OrderSpot } from '@/App/tiles/orders/components/OrderSpot.tsx';
import { useStopLossTileId } from '@/App/tiles/orders/StopLossOrder/StopLossOrderCreationTile/stopLossContext.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectSpotStopLossData } from '@/store/orders/stopLoss/selectors.ts';

export const ConnectedStopLossOrderSpot = memo(() => {
  const tileId = useStopLossTileId();
  const spotDate = useAppSelector((state) => selectSpotStopLossData(state, tileId));

  return <OrderSpot spotDate={spotDate} />;
});
